export default __webpack_public_path__ + "static/media/angular.edb41932.png";